import React from 'react';
import { withUnreadDivider } from '../../components/common/chat/timeline/chatUnreadDivider';
import AdminSidebar from '../../components/admin/Sidebar';
import ChatEmptyState from '../../components/common/chat/shared/ChatEmptyState';
import DsSwitch from '../../components/common/DsSwitch';
import ChatRetentionEmptyNotice from '../../components/common/chat/shared/ChatRetentionEmptyNotice';
import ChatComposer from '../../components/common/chat/composer/ChatComposer';
import ChatImageModal from '../../components/common/chat/composer/ChatImageModal';
import ChatDragOverlay from '../../components/common/chat/composer/ChatDragOverlay';
import GroupStandardMessageRow from '../../components/common/chat/timeline/GroupStandardMessageRow';
import ChatNoteSystemMessageRow from '../../components/common/chat/notes/ChatNoteSystemMessageRow';
import AccountAvatarTrigger from '../../components/common/chat/avatars/AccountAvatarTrigger';
import ChatTargetListRow from '../../components/common/chat/sidepanel/ChatTargetListRow';
import ChatMentionTaskNotice from '../../components/common/chat/mentions/ChatMentionTaskNotice';
import { renderChatSearchHighlight } from '../../components/common/chat/search/chatSearchHighlight';
import ChatMentionTaskResolutionModal from '../../components/common/chat/mentions/ChatMentionTaskResolutionModal';
import ChatTargetSidebarLoading from '../../components/common/chat/sidepanel/ChatTargetSidebarLoading';
import ChatTargetSidebarToolbar from '../../components/common/chat/sidepanel/ChatTargetSidebarToolbar';
import ChatTargetSwitchFab from '../../components/common/chat/sidepanel/ChatTargetSwitchFab';
import ChatTargetSearchModal from '../../components/common/chat/search/ChatTargetSearchModal';
import ChatWorkspaceLayout from '../../components/common/chat/shared/ChatWorkspaceLayout';
import ChatAreaHeader from '../../components/common/chat/shared/ChatAreaHeader';
import { formatItemCount } from '../../utils/datetime';
import { IMAGE_UPLOAD_ACCEPT_ATTR } from '../../utils/imageUploadCompatibility';
import ChatHeaderIconButton from '../../components/common/chat/shared/ChatHeaderIconButton';
import ChatHeaderOverflowMenu from '../../components/common/chat/shared/ChatHeaderOverflowMenu';
import ChatLinksModal from '../../components/common/chat/assets/ChatLinksModal';
import ChatMediaModal from '../../components/common/chat/assets/ChatMediaModal';
import { adminGroupChatAssetSource } from '../../api/chatAssets';
import ChatSidePanelToggleButton from '../../components/common/chat/sidepanel/ChatSidePanelToggleButton';
import ChatSidePanelHeader from '../../components/common/chat/sidepanel/ChatSidePanelHeader';
import ChatFollowupInbox from '../../components/common/chat/followups/ChatFollowupInbox';
import ChatFollowupNotificationMenu from '../../components/common/chat/followups/ChatFollowupNotificationMenu';
import AiFluidMark from '../../components/common/chat/shared/AiFluidMark';
import MemberListModalLayout from '../../components/common/chat/members/MemberListModalLayout';
import MemberListModalContent from '../../components/common/chat/members/MemberListModalContent';
import ArtistCandidateSelectorPanel from '../../components/common/chat/members/ArtistCandidateSelectorPanel';
import GroupChatParticipantsPanel from '../../components/common/chat/members/GroupChatParticipantsPanel';
import ChatSidePanelCard from '../../components/common/chat/sidepanel/ChatSidePanelCard';
import ChatSidePanelProfileBlock from '../../components/common/chat/sidepanel/ChatSidePanelProfileBlock';
import ChatProfileModalLayer from '../../components/common/chat/members/ChatProfileModalLayer';
import ChatAnnouncementBar from '../../components/common/chat/announcements/ChatAnnouncementBar';
import ChatAnnouncementListModal from '../../components/common/chat/announcements/ChatAnnouncementListModal';
import ChatMessageReactionBar from '../../components/common/chat/reactions/ChatMessageReactionBar';
import ChatMessageMenuReactionPicker from '../../components/common/chat/reactions/ChatMessageMenuReactionPicker';
import ChatMessageReactionDetailModal from '../../components/common/chat/reactions/ChatMessageReactionDetailModal';
import ChatMessageReadStatusDetailModal from '../../components/common/chat/reactions/ChatMessageReadStatusDetailModal';
import ChatReplySnippet from '../../components/common/chat/composer/ChatReplySnippet';
import { AdminGroupChatGuidanceMessage } from '../../components/common/chat/timeline/ArtistChatGuidanceSystemMessages';
import { supportsChatMessageReaction } from '../../components/common/chat/reactions/chatMessageReactionUtils';
import AdminGroupNotesPanel from '../../components/admin/chats/AdminGroupNotesPanel';
import CropModal from '../../components/common/CropModal';
import { sidebarTimeLabelJST } from '../../utils/datetime';
import { appendVariant } from '../../components/common/chat/composer/chatAssetUtils';
import { buildGroupChatMessagePresentation } from '../../components/common/chat/timeline/groupChatMessageUtils';
import { isGroupNoteMessage } from '../../components/common/chat/notes/groupNoteMessageUtils';
import { createGroupParticipantsPanelProps } from '../../components/common/chat/members/groupParticipantsPanelConfigUtils';
import {
  CHAT_FOLLOWUP_AI_TARGET_ID,
  resolveChatFollowupBadgeToneClass,
} from '../../components/common/chat/followups/chatFollowupApi';
import { API_URL, MESSAGE_IMAGE_PATH, MESSAGE_FILE_PATH, ARTIST_PROFILE_IMAGE_PATH, ADMIN_PROFILE_IMAGE_PATH, buildAssetUrl, GROUP_TARGET_ROW_CLASSES, fmtDateTime, getThreadModeLabel, getThreadStatusLabel, getThreadPreviewText, getArtistAvatarStyle, getAdminAvatarStyle, getArtistPictureKey, getGroupChatIconStyle, hasGroupChatDisplayImage } from '../../components/admin/chats/adminGroupChatPageHelpers';
import DsSelect from '../../components/common/DsSelect';

export default function AdminGroupChatPageView({ context }) {
  const [showLinksModal, setShowLinksModal] = React.useState(false);
  const [showMediaModal, setShowMediaModal] = React.useState(false);
  const chatAssetSource = React.useMemo(
    () => (context?.selectedThreadId ? adminGroupChatAssetSource(context.selectedThreadId) : null),
    [context?.selectedThreadId],
  );
  const {
    activeAnchorMessageId,
    activeSearchFilterCount,
    addAllCreateCandidates,
    addAllMemberCandidates,
    addingMembers,
    adminArtistChatTone,
    adminAvatarStyleForMemberPeople,
    adminInitialForMemberPeople,
    adminMessageCount,
    adminUsers,
    announcementActionMessageId,
    announcementCount,
    announcements,
    applyAssigneeModal,
    applyTargetSearchModal,
    artistAvatarInitialForMemberPeople,
    artistAvatarStyleForMemberPeople,
    artistGroups,
    artistKeyword,
    assigneeDraftIds,
    assigneeKeyword,
    assigneeQuickToggles,
    buildAdminProfileData,
    buildArtistProfileData,
    canAnnouncementMessage,
    canCopyMessage,
    canInspectReadStatus,
    canManageGroupNotes,
    canReactMessage,
    canReplyMessage,
    canSwitchToPersonalChat,
    canUnsendMessage,
    canViewGroupNotes,
    candidateSelection,
    chatDropScopeRef,
    clearMessageLongPress,
    clearSidebarContextMenuBlock,
    clearSidebarLongPress,
    clearTargetSearchModal,
    closeAssigneeModal,
    closeImageModal,
    closeMembersAddModal,
    closeMembersModal,
    closeMessageMenu,
    closeProfileModal,
    closeReactionDetail,
    closeReadStatusDetail,
    closeSettingsModal,
    createArtistAccountType,
    createArtistCandidates,
    createArtistFilterGroupId,
    createArtistFilterPart,
    createArtistKeyword,
    createGroupId,
    createMode,
    createOpen,
    createSelectedArtistIdSet,
    createSelectedArtists,
    createTitle,
    currentStatusIconClass,
    currentStatusLabel,
    deletingIcon,
    deletingThread,
    displayMessages,
    unreadDividerMessageId,
    filteredAdminUsers,
    filteredThreads,
    followupBadgeCount,
    followupRefreshKey,
    followupSummary,
    formatAdminNameForMemberPeople,
    goBackMobile,
    groupedMemberArtistSections,
    groupedSidePanelArtists,
    handleAddMembers,
    handleComposerSent,
    handleCopyMessage,
    handleCreate,
    handleDeleteIcon,
    handleDeleteThread,
    handleIconFileChange,
    handleJumpToReplyMessage,
    handleMentionClick,
    handleMessageContextMenu,
    handleMessageMenuReactionSelect,
    handleMessageTouchStart,
    handleOpenAiTask,
    handleOpenInlinePartialCopy,
    handleOpenPersonalChatFromTargetList,
    handleOpenReadStatusDetail,
    handleRemoveMember,
    handleSaveCroppedIcon,
    handleSaveSettings,
    handleSelectAnnouncementMessage,
    handleSelectReplyMessage,
    handleSidebarTouchStart,
    handleToggleAnnouncementMessage,
    handleToggleMute,
    handleToggleStatus,
    handleUnsendMessage,
    hasMoreMessages,
    iconCropImageSrc,
    imageItems,
    imgModalIndex,
    imgModalOpen,
    inlineCopyMessageId,
    isAiTargetSelected,
    isAnnouncedMessage,
    isAnnouncementListOpen,
    isDragActive,
    isGroupChatAreaOpen,
    isNarrow,
    isReactionDetailOpen,
    isReactionPending,
    isReadStatusDetailOpen,
    isSidePanelLayoutOpen,
    isSidePanelOpen,
    latestAnnouncement,
    loadMessages,
    loadThreadDetail,
    loadingAdminUsers,
    loadingArtistCandidates,
    loadingCreateArtistCandidates,
    loadingGroups,
    loadingMembers,
    loadingMentionResolutionTargetKey,
    loadingMute,
    loadingOlderMessages,
    loadingParts,
    loadingThreadDetail,
    loggedInAdminId,
    manualCandidateRows,
    memberAddAccountType,
    memberAddFilterGroupId,
    memberAddFilterPart,
    membersPayload,
    mentionCandidates,
    mentionResolutionModalProps,
    messageMenu,
    messageMenuRef,
    messageSearch,
    messages,
    messagesContainerRef,
    mobileListPrefRef,
    mobileView,
    noteCount,
    openAdminProfile,
    openAiInbox,
    openArtistProfile,
    openAssigneeModal,
    openImageModal,
    openMembersAddModal,
    openMembersModal,
    openMentionResolution,
    openMessageAvatarProfile,
    openReactionDetail,
    openSettingsModal,
    openTargetSearchModal,
    overlayRect,
    parts,
    pendingAnchorRef,
    pendingMentionTargets,
    profileTarget,
    reactionDetailGroups,
    reactionDetailLoading,
    readStatusDetailLoading,
    readStatusDetailReaders,
    refreshNoteCount,
    removeCreateArtist,
    removingArtistId,
    renderPartialCopyContent,
    replyDraft,
    resolveArtistShortPart,
    resolveMentionTarget,
    resolvingMentionTargetId,
    rootClasses,
    savingCreate,
    savingMute,
    savingSettings,
    searchDraft,
    searchSummaryLabel,
    searchToolbarChips,
    selectedAssigneeNames,
    selectedAssignees,
    selectedThread,
    selectedThreadId,
    setArtistKeyword,
    setAssigneeKeyword,
    setCandidateSelection,
    setCreateArtistAccountType,
    setCreateArtistFilterGroupId,
    setCreateArtistFilterPart,
    setCreateArtistKeyword,
    setCreateGroupId,
    setCreateMode,
    setCreateOpen,
    setCreateSelectedArtists,
    setCreateTitle,
    setIconCropImageSrc,
    setIsAiTargetSelected,
    setIsAnnouncementListOpen,
    setIsSidePanelOpen,
    setMemberAddAccountType,
    setMemberAddFilterGroupId,
    setMemberAddFilterPart,
    setMobileView,
    setReplyDraft,
    setSearchDraft,
    setSelectedThreadId,
    setSettingsTitle,
    setShowCreateArtistModal,
    setShowIconCropModal,
    setShowNotes,
    setShowSearchModal,
    settingsIconFileInputRef,
    settingsModalThread,
    settingsTitle,
    shouldShowEmptyMessages,
    shouldShowSidePanel,
    shouldShowThreadSkeleton,
    shouldSuppressThreadUnread,
    showAssigneeModal,
    showCreateArtistModal,
    showDelayedInitialLoading,
    showIconCropModal,
    showMembersAddModal,
    showMembersModal,
    showNextImage,
    showNotes,
    showPrevImage,
    showSearchModal,
    showSettingsModal,
    sidebarPressRef,
    threadMuted,
    toastError,
    toastSuccess,
    toggleAssigneeDraft,
    toggleCandidate,
    toggleCreateArtist,
    toggleReaction,
    toggleStatusLabel,
    togglingStatus,
    unpinAnnouncement,
    unsendingMessageId,
    uploadingIcon,
  } = context;
  const followupBadgeToneClass =
    followupBadgeCount > 0 ? resolveChatFollowupBadgeToneClass(followupSummary) : '';

  const [followupNotificationMenu, setFollowupNotificationMenu] = React.useState(null);
  const closeFollowupNotificationMenu = React.useCallback(() => {
    setFollowupNotificationMenu(null);
  }, []);
  const openFollowupNotificationMenuAt = React.useCallback((clientX, clientY) => {
    setFollowupNotificationMenu({ x: clientX, y: clientY });
  }, []);
  const blockFollowupContextMenu = React.useCallback(() => {
    clearSidebarContextMenuBlock();
    sidebarPressRef.current.suppressContextMenu = true;
    sidebarPressRef.current.contextMenuTimer = window.setTimeout(() => {
      sidebarPressRef.current.suppressContextMenu = false;
      sidebarPressRef.current.contextMenuTimer = null;
    }, 700);
  }, [clearSidebarContextMenuBlock, sidebarPressRef]);
  const handleAiTargetTouchStart = React.useCallback((event) => {
    sidebarPressRef.current.suppressClick = false;
    clearSidebarContextMenuBlock();
    clearSidebarLongPress();
    if (!isNarrow) return;
    const touch = event.touches?.[0];
    const clientX = touch?.clientX ?? window.innerWidth / 2;
    const clientY = touch?.clientY ?? 72;
    sidebarPressRef.current.timer = window.setTimeout(() => {
      sidebarPressRef.current.timer = null;
      sidebarPressRef.current.suppressClick = true;
      blockFollowupContextMenu();
      openFollowupNotificationMenuAt(clientX, clientY);
    }, 520);
  }, [
    blockFollowupContextMenu,
    clearSidebarContextMenuBlock,
    clearSidebarLongPress,
    isNarrow,
    openFollowupNotificationMenuAt,
    sidebarPressRef,
  ]);

  return (<div className="admin-dashboard">
      <AdminSidebar />
      <div className={rootClasses}>
        <ChatWorkspaceLayout className="admin-group-chat-workspace">
        <div className="admin-message-sidebar chat-target-sidebar">
          <ChatTargetSidebarToolbar
            onOpenSearch={openTargetSearchModal}
            summary={searchSummaryLabel}
            chips={searchToolbarChips}
            toggles={assigneeQuickToggles}
          >
            {!isNarrow ? (
              <button
                type="button"
                className="chat-target-sidebar-toolbar__button is-sub"
                onClick={() => setCreateOpen(true)}
              >
                + 新規作成
              </button>
            ) : null}
          </ChatTargetSidebarToolbar>

          <ul aria-busy={shouldShowThreadSkeleton ? 'true' : 'false'}>
            {activeSearchFilterCount > 0 ? (
              <li className="event-list__result-header">
                <span className="event-list__result-count">
                  <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
                  検索結果 {formatItemCount(filteredThreads.length || 0)}
                </span>
                <button
                  type="button"
                  className="event-list__result-clear"
                  onClick={clearTargetSearchModal}
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true" />
                  <span>解除</span>
                </button>
              </li>
            ) : (
              <ChatTargetListRow
                key={CHAT_FOLLOWUP_AI_TARGET_ID}
                className={isAiTargetSelected ? 'active' : ''}
                classNames={{
                  ...GROUP_TARGET_ROW_CLASSES,
                  center: `${GROUP_TARGET_ROW_CLASSES.center} chat-followup-target-row__center`,
                  right: `${GROUP_TARGET_ROW_CLASSES.right} chat-followup-target-row__side`,
                }}
                onClick={() => {
                  if (sidebarPressRef.current.suppressClick) {
                    sidebarPressRef.current.suppressClick = false;
                    return;
                  }
                  openAiInbox();
                }}
                onContextMenu={(event) => {
                  if (sidebarPressRef.current.suppressContextMenu) {
                    event.preventDefault();
                    event.stopPropagation();
                    clearSidebarContextMenuBlock();
                    return;
                  }
                  event.preventDefault();
                  event.stopPropagation();
                  sidebarPressRef.current.suppressClick = true;
                  openFollowupNotificationMenuAt(event.clientX, event.clientY);
                  setTimeout(() => {
                    sidebarPressRef.current.suppressClick = false;
                  }, 0);
                }}
                onTouchStart={handleAiTargetTouchStart}
                onTouchEnd={clearSidebarLongPress}
                onTouchCancel={clearSidebarLongPress}
                onTouchMove={clearSidebarLongPress}
                avatar={(
                  <AiFluidMark variant="sidebar" className="chat-followup-target-row__eventAiMark" />
                )}
                title="CasticartAI"
                badge={followupBadgeCount > 0 ? (followupBadgeCount > 99 ? '99+' : followupBadgeCount) : null}
                badgeClassName={followupBadgeToneClass}
              />
            )}
            {shouldShowThreadSkeleton ? (
              <ChatTargetSidebarLoading variant="row" count={6} />
            ) : null}
            {!shouldShowThreadSkeleton &&
              filteredThreads.map((thread) => {
                const unreadCount = shouldSuppressThreadUnread(thread?.thread_id) ||
                  (
                    isGroupChatAreaOpen &&
                    !isAiTargetSelected &&
                    String(selectedThreadId || '') === String(thread?.thread_id || '')
                  )
                  ? 0
                  : Number(thread.unread_count || 0);
                const isAssignedToMe = Boolean(thread?.is_assigned_to_me);
                const unreadBadgeToneClass = isAssignedToMe ? 'badge-tone--alert' : 'badge-tone--ok';
                const isNotifyMuted = !!thread.admin_muted;
                const rowKey = thread.search_hit_message_id
                  ? `${thread.thread_id}-${thread.search_hit_message_id}`
                  : String(thread.thread_id || '');
                const isMessageHit = thread.search_result_type === 'message-hit';
                // 検索/絞り込み中は受信箱の未対応メンションCTAを結果に混ぜない
                const mentionTask = activeSearchFilterCount > 0
                  ? null
                  : pendingMentionTargets[String(thread.thread_id || '').trim()] || null;
                return (
                  <ChatTargetListRow
                    key={rowKey}
                    classNames={GROUP_TARGET_ROW_CLASSES}
                    className={`${!isAiTargetSelected && selectedThreadId === thread.thread_id ? 'active' : ''} ${
                      thread.status !== 'open' ? 'group-chat-page__threadClosed' : ''
                    }`}
                    onClick={() => {
                      if (sidebarPressRef.current.suppressClick) {
                        sidebarPressRef.current.suppressClick = false;
                        return;
                      }
                      const hitMessageId = String(thread?.search_hit_message_id || '').trim();
                      if (hitMessageId) {
                        pendingAnchorRef.current = {
                          threadId: thread.thread_id,
                          messageId: hitMessageId,
                        };
                      } else {
                        pendingAnchorRef.current = null;
                      }
                      if (
                        !isAiTargetSelected &&
                        String(selectedThreadId || '') === String(thread.thread_id || '')
                      ) {
                        if (isNarrow) {
                          mobileListPrefRef.current = false;
                          setMobileView('chat');
                        }
                        loadThreadDetail(thread.thread_id);
                        loadMessages(thread.thread_id, {
                          anchorMessageId: hitMessageId,
                          markRead: true,
                        });
                        return;
                      }
                      setIsAiTargetSelected(false);
                      setSelectedThreadId(thread.thread_id);
                      if (isNarrow) {
                        mobileListPrefRef.current = false;
                        setMobileView('chat');
                      }
                    }}
                    onContextMenu={(event) => {
                      if (sidebarPressRef.current.suppressContextMenu) {
                        event.preventDefault();
                        event.stopPropagation();
                        clearSidebarContextMenuBlock();
                        return;
                      }
                      event.preventDefault();
                      sidebarPressRef.current.suppressClick = true;
                      openSettingsModal(thread, { selectOnOpen: false });
                      setTimeout(() => {
                        sidebarPressRef.current.suppressClick = false;
                      }, 0);
                    }}
                    onTouchStart={() => {
                      sidebarPressRef.current.suppressClick = false;
                      clearSidebarContextMenuBlock();
                      handleSidebarTouchStart(thread);
                    }}
                    onTouchEnd={clearSidebarLongPress}
                    onTouchCancel={clearSidebarLongPress}
                    onTouchMove={clearSidebarLongPress}
                    avatar={
                      <div className="artist-avatar group-chat-page__avatar chat-target-row__avatar" style={getGroupChatIconStyle(thread)}>
                        {!hasGroupChatDisplayImage(thread) ? (String(thread.title || '').slice(0, 1) || 'G') : ''}
                        {isNotifyMuted ? (
                          <span className="artist-mute-badge" aria-hidden="true" title="通知オフ">
                            <i className="fa-solid fa-bell-slash" aria-hidden="true"></i>
                          </span>
                        ) : null}
                      </div>
                    }
                    title={thread.title}
                    preview={isMessageHit ? undefined : (thread.linked_event_name || getThreadPreviewText(thread))}
                    previewNode={
                      isMessageHit ? (
                        <span className={GROUP_TARGET_ROW_CLASSES.preview}>
                          {renderChatSearchHighlight(getThreadPreviewText(thread), messageSearch)}
                        </span>
                      ) : undefined
                    }
                    belowContent={
                      mentionTask?.count > 0 ? (
                        <ChatMentionTaskNotice
                          count={mentionTask.count}
                          disabled={
                            resolvingMentionTargetId === String(thread.thread_id || '').trim() ||
                            loadingMentionResolutionTargetKey === `group:${String(thread.thread_id || '').trim()}`
                          }
                          onResolve={() =>
                            openMentionResolution({
                              scope: 'group',
                              targetId: thread.thread_id,
                              count: mentionTask.count,
                              title: thread.title ? `${thread.title} の未対応メンション` : '未対応メンション',
                              resolveTarget: resolveMentionTarget,
                            })
                          }
                          onOpen={() => {
                            const messageId = String(mentionTask.messageId || '').trim();
                            if (!messageId) return;
                            pendingAnchorRef.current = {
                              threadId: thread.thread_id,
                              messageId,
                            };
                            if (
                              !isAiTargetSelected &&
                              String(selectedThreadId || '') === String(thread.thread_id || '')
                            ) {
                              loadThreadDetail(thread.thread_id);
                              loadMessages(thread.thread_id, {
                                anchorMessageId: messageId,
                                markRead: true,
                              });
                            } else {
                              setIsAiTargetSelected(false);
                              setSelectedThreadId(thread.thread_id);
                            }
                            if (isNarrow) {
                              mobileListPrefRef.current = false;
                              setMobileView('chat');
                            }
                          }}
                        />
                      ) : null
                    }
                    time={sidebarTimeLabelJST(thread.latest_message_at || thread.updated_at)}
                    badge={!isMessageHit && unreadCount > 0 ? (unreadCount > 99 ? '99+' : unreadCount) : null}
                    badgeClassName={!isMessageHit && unreadCount > 0 ? unreadBadgeToneClass : ''}
                  />
                );
              })}
            {!shouldShowThreadSkeleton && filteredThreads.length === 0 ? (
              <li className="event-list__empty-hint">
                {activeSearchFilterCount > 0
                  ? '一致するチャットはありません。条件を変えるか「解除」してください。'
                  : '該当するチャットがありません。'}
              </li>
            ) : null}
          </ul>
          {canSwitchToPersonalChat ? (
            <ChatTargetSwitchFab
              label="アーティストチャットへ切り替え"
              iconClassName="fa-solid fa-comments"
              unreadCount={adminMessageCount}
              badgeToneClassName={
                adminArtistChatTone === 'ok'
                  ? 'sidebar-count-badge--ok'
                  : 'sidebar-count-badge--alert'
              }
              onClick={handleOpenPersonalChatFromTargetList}
              secondaryAction={{
                label: 'グループチャットを新規作成',
                iconClassName: 'fa-solid fa-plus',
                onClick: () => setCreateOpen(true),
              }}
            />
          ) : null}
        </div>

        <ChatTargetSearchModal
          isOpen={showSearchModal}
          title="グループチャット検索"
          onClose={() => setShowSearchModal(false)}
          onApply={applyTargetSearchModal}
          onClear={clearTargetSearchModal}
          summary={searchSummaryLabel}
        >
          <div className="chat-target-search-form">
            <div className="chat-target-search-form__field">
              <label className="chat-target-search-form__label" htmlFor="group-thread-search">
                チャット名/連動グループ
              </label>
              <input
                id="group-thread-search"
                className="chat-target-search-form__input"
                type="text"
                value={searchDraft.thread}
                onChange={(event) =>
                  setSearchDraft((current) => ({ ...current, thread: event.target.value }))
                }
                placeholder="タイトルや連動グループで絞り込み"
              />
            </div>

            <div className="chat-target-search-form__field">
              <label className="chat-target-search-form__label" htmlFor="group-mode-search">
                モード
              </label>
              <DsSelect
                id="group-mode-search"
                className="chat-target-search-form__select"
                value={searchDraft.mode}
                onChange={(event) =>
                  setSearchDraft((current) => ({ ...current, mode: event.target.value }))
                }
              >
                <option value="">すべて</option>
                <option value="manual">手動</option>
                <option value="artist_group_linked">グループ連動</option>
              </DsSelect>
            </div>

            <div className="chat-target-search-form__field">
              <label className="chat-target-search-form__label" htmlFor="group-status-search">
                ステータス
              </label>
              <DsSelect
                id="group-status-search"
                className="chat-target-search-form__select"
                value={searchDraft.status}
                onChange={(event) =>
                  setSearchDraft((current) => ({ ...current, status: event.target.value }))
                }
              >
                <option value="">すべて</option>
                <option value="open">公開中</option>
                <option value="closed">クローズ</option>
              </DsSelect>
            </div>

            <div className="chat-target-search-form__field">
              <label className="chat-target-search-form__label" htmlFor="group-linked-group-search">
                連動グループ
              </label>
              <DsSelect
                id="group-linked-group-search"
                className="chat-target-search-form__select"
                value={searchDraft.groupId}
                onChange={(event) =>
                  setSearchDraft((current) => ({ ...current, groupId: event.target.value }))
                }
              >
                <option value="">すべて</option>
                {artistGroups.map((group) => (
                  <option key={group.group_id} value={String(group.group_id)}>
                    {group.group_name}
                  </option>
                ))}
              </DsSelect>
            </div>

            <div className="chat-target-search-form__field">
              <label className="chat-target-search-form__label" htmlFor="group-message-search">
                チャット本文
              </label>
              <input
                id="group-message-search"
                className="chat-target-search-form__input"
                type="text"
                value={searchDraft.message}
                onChange={(event) =>
                  setSearchDraft((current) => ({ ...current, message: event.target.value }))
                }
                placeholder="本文キーワード"
              />
            </div>

          </div>
        </ChatTargetSearchModal>

        <div className={`chat-main-with-side${isSidePanelLayoutOpen ? '' : ' is-side-panel-collapsed'}`}>
          <div className="admin-message-chat-container chat-area chat-dnd-scope" ref={chatDropScopeRef}>
            {isAiTargetSelected ? (
              <ChatFollowupInbox
                initialSummary={followupSummary}
                refreshKey={followupRefreshKey}
                onOpenTask={handleOpenAiTask}
                onBack={goBackMobile}
                showBackButton={Boolean(isNarrow && mobileView === 'chat')}
              />
            ) : !selectedThreadId ? (
              <ChatEmptyState ariaLabel="グループチャットが未選択です" />
            ) : (
              <>
                <ChatAreaHeader
                  className="admin-message-chat-header"
                  mainClassName="profile-info group-chat-page__headerProfile"
                  showBackButton={Boolean(isNarrow && mobileView === 'chat')}
                  onBack={goBackMobile}
                  backButtonClassName="chat-header-back-btn"
                  backAriaLabel="戻る"
                  backTitle="戻る"
                  main={(
                    <>
                      <div className="profile-image group-chat-page__avatar" style={getGroupChatIconStyle(selectedThread)}>
                        {!hasGroupChatDisplayImage(selectedThread) ? (String(selectedThread?.title || '').slice(0, 1) || 'G') : ''}
                      </div>
                      <div className="artist-info">
                        <span className="artist-info__name">{selectedThread?.title || '...'}</span>
                        {selectedThread?.linked_event_name ? (
                          <span className="artist-info__subtitle">{selectedThread.linked_event_name}</span>
                        ) : null}
                      </div>
                    </>
                  )}
                  actionsClassName="group-chat-page__headerActions chat-header-action-group"
                  actions={(
                    <>
                      {canViewGroupNotes ? (
                        <ChatHeaderIconButton
                          onClick={() => setShowNotes((current) => !current)}
                          className="chat-header-icon-button"
                          title={showNotes ? 'チャットに戻る' : 'ノート'}
                          aria-label={showNotes ? 'チャットに戻る' : 'ノート'}
                          iconClassName={`fa-solid ${showNotes ? 'fa-comment' : 'fa-note-sticky'}`}
                          badgeCount={showNotes ? 0 : noteCount}
                        />
                      ) : null}
                      <ChatHeaderIconButton
                        onClick={openMembersModal}
                        className="chat-header-icon-button"
                        title="メンバーリスト"
                        aria-label="メンバーリスト"
                        iconClassName="fa-solid fa-people-group"
                        badgeCount={Array.isArray(selectedThread?.artists) ? selectedThread.artists.length : 0}
                        showZeroBadge
                      />
                      <button
                        type="button"
                        onClick={openSettingsModal}
                        className="settings-button chat-header-icon-button"
                        title="設定"
                        aria-label="設定"
                      >
                        <i className="fa-solid fa-gear" aria-hidden="true"></i>
                      </button>
                      <ChatHeaderOverflowMenu
                        items={[
                          { key: 'links', icon: 'fa-link', label: 'リンク', onClick: () => setShowLinksModal(true) },
                          { key: 'media', icon: 'fa-photo-film', label: '写真・ファイル', onClick: () => setShowMediaModal(true) },
                        ]}
                      />
                      <button
                        type="button"
                        onClick={handleToggleStatus}
                        disabled={!selectedThread || togglingStatus || loadingThreadDetail}
                        className="settings-button chat-header-icon-button"
                        title={
                          currentStatusLabel && toggleStatusLabel
                            ? `現在: ${currentStatusLabel}（クリックで${toggleStatusLabel}）`
                            : toggleStatusLabel
                        }
                        aria-label={
                          currentStatusLabel && toggleStatusLabel
                            ? `現在: ${currentStatusLabel}。クリックで${toggleStatusLabel}`
                            : toggleStatusLabel
                        }
                      >
                        <i className={`fa-solid ${currentStatusIconClass}`} aria-hidden="true"></i>
                      </button>
                    </>
                  )}
                />

                {!showNotes ? (
                  <ChatAnnouncementBar
                    announcement={latestAnnouncement}
                    count={announcementCount}
                    onOpenList={() => setIsAnnouncementListOpen(true)}
                  />
                ) : null}

                {showNotes && canViewGroupNotes ? (
                  <AdminGroupNotesPanel
                    threadId={selectedThreadId}
                    onModeChange={() => {}}
                    onNotesChanged={refreshNoteCount}
                    canCreateNote={canManageGroupNotes}
                    canManageNotes={canManageGroupNotes}
                  />
                ) : (
                  <>
                    <div className="admin-message-chat-messages chat-message-stack" ref={messagesContainerRef}>
                      <ChatDragOverlay
                        show={isDragActive}
                        rect={overlayRect}
                        title="ここにドロップで送信"
                        sub="画像（最大5枚）またはファイル1件（100MBまで）"
                      />
                      {showDelayedInitialLoading ? (
                        <div className="chat-loading-overlay" aria-label="読み込み中">
                          <div className="chat-spinner" aria-hidden="true"></div>
                        </div>
                      ) : null}
                      {withUnreadDivider(displayMessages.map((message) => {
                        const formattedTime = fmtDateTime(message.created_at);
                        if (isGroupNoteMessage(message)) {
                          const presentation = buildGroupChatMessagePresentation({
                            message,
                            viewerRole: 'admin',
                            currentAdminId: loggedInAdminId,
                            apiUrl: API_URL,
                            paths: {
                              adminProfilePath: ADMIN_PROFILE_IMAGE_PATH,
                              artistProfilePath: ARTIST_PROFILE_IMAGE_PATH,
                              messageImagePath: MESSAGE_IMAGE_PATH,
                              messageFilePath: MESSAGE_FILE_PATH,
                            },
                            withDownloadQuery: true,
                          });
                          return (
                            <ChatNoteSystemMessageRow
                              key={message.id}
                              message={message}
                              variant="im"
                              avatarNode={(
                                <AccountAvatarTrigger
                                  className={[
                                    'chat-avatar',
                                    presentation.isAdminSender && !presentation.avatarUrl ? 'is-admin' : '',
                                    presentation.isAdminSender ? 'is-admin-identity' : '',
                                  ].filter(Boolean).join(' ')}
                                  imageUrl={presentation.avatarUrl}
                                  style={
                                    presentation.avatarUrl
                                      ? undefined
                                      : presentation.avatarStyle
                                  }
                                  fallback={<span className="chat-avatar-initial">{presentation.avatarInitial}</span>}
                                />
                              )}
                              senderName={presentation.senderName}
                              authorIsAdmin={presentation.isAdminSender}
                              bubbleClassName="admin-message system-message"
                              timeLabel={formattedTime}
                              activeAnchorMessageId={activeAnchorMessageId}
                              anchorClassName="group-chat-page__messageAnchor"
                              onOpenNote={canViewGroupNotes ? ((noteId) => {
                                setShowNotes(true);
                                if (noteId) {
                                  window.setTimeout(() => {
                                    window.dispatchEvent(
                                      new CustomEvent('admin-group-notes-open-detail', { detail: { noteId } })
                                    );
                                  }, 0);
                                }
                              }) : undefined}
                            />
                          );
                        }
                        const presentation = buildGroupChatMessagePresentation({
                          message,
                          viewerRole: 'admin',
                          currentAdminId: loggedInAdminId,
                          apiUrl: API_URL,
                          paths: {
                            adminProfilePath: ADMIN_PROFILE_IMAGE_PATH,
                            artistProfilePath: ARTIST_PROFILE_IMAGE_PATH,
                            messageImagePath: MESSAGE_IMAGE_PATH,
                            messageFilePath: MESSAGE_FILE_PATH,
                          },
                          withDownloadQuery: true,
                        });
                        const isSelf = presentation.isSelf;
                        const normalizedMessageId = String(message?.id || '').trim();
                        const hasCopyFocus = Boolean(
                          normalizedMessageId &&
                          inlineCopyMessageId &&
                          inlineCopyMessageId === normalizedMessageId
                        );
                        const shouldDimRow = Boolean(
                          inlineCopyMessageId &&
                          normalizedMessageId &&
                          inlineCopyMessageId !== normalizedMessageId
                        );
                        return (
                          <GroupStandardMessageRow
                            key={message.id}
                            message={message}
                            presentation={{
                              ...presentation,
                              avatarStyle: presentation.avatarStyle,
                            }}
                            isSelf={isSelf}
                            variant="im"
                            selfBubbleClass="artist-message"
                            otherBubbleClass="admin-message"
                            bubbleClassName={hasCopyFocus ? 'chat-message-row__bubbleWrap--copyActive' : ''}
                            rowClassName={
                              hasCopyFocus
                                ? 'chat-message-row--copyActive'
                                : shouldDimRow
                                  ? 'chat-message-row--copyDimmed'
                                  : ''
                            }
                            timeLabel={formattedTime}
                            activeAnchorMessageId={activeAnchorMessageId}
                            anchorClassName="group-chat-page__messageAnchor"
                            avatarClassName="chat-avatar"
                            avatarClickableClassName="chat-avatar--clickable"
                            avatarFallbackClassName="chat-avatar-initial"
                            onAvatarClick={() => openMessageAvatarProfile(message)}
                            onContextMenu={inlineCopyMessageId ? undefined : (event) => handleMessageContextMenu(event, message)}
                            onTouchStart={inlineCopyMessageId ? undefined : (event) => handleMessageTouchStart(event, message)}
                            onTouchEnd={inlineCopyMessageId ? undefined : clearMessageLongPress}
                            onTouchCancel={inlineCopyMessageId ? undefined : clearMessageLongPress}
                            onTouchMove={inlineCopyMessageId ? undefined : clearMessageLongPress}
                            onImageClick={() => openImageModal(message.id)}
                            onMentionClick={handleMentionClick}
                            fileVariant="simple"
                            replyHeaderContent={message.reply ? (
                              <ChatReplySnippet
                                reply={message.reply}
                                onClick={() => handleJumpToReplyMessage(message.reply)}
                              />
                            ) : null}
                            wrapContent={(contentNode, msg) => renderPartialCopyContent(msg, contentNode, isSelf)}
                            sideActionContent={
                              !inlineCopyMessageId &&
                              !isSelf && supportsChatMessageReaction(message) ? (
                                <ChatMessageReactionBar
                                  messageId={message.id}
                                  reactions={message.reactions}
                                  canReact
                                  showReactionChips={false}
                                  onToggleReaction={toggleReaction}
                                  onOpenDetail={openReactionDetail}
                                  isPending={isReactionPending}
                                  compact
                                />
                              ) : null
                            }
                            metaEndContent={
                              Array.isArray(message.reactions) &&
                              message.reactions.length > 0 ? (
                                <ChatMessageReactionBar
                                  messageId={message.id}
                                  reactions={message.reactions}
                                  canReact={false}
                                  onOpenDetail={openReactionDetail}
                                  isPending={isReactionPending}
                                  showAddButton={false}
                                />
                              ) : null
                            }
                          />
                        );
                      }), displayMessages, unreadDividerMessageId)}
                      {!hasMoreMessages && !loadingOlderMessages && selectedThreadId ? (
                        <AdminGroupChatGuidanceMessage />
                      ) : null}
                      {loadingOlderMessages && messages.length > 0 ? (
                        <div className="chat-paging-loading" aria-label="追加読み込み中">
                          <div className="chat-spinner chat-spinner--small" aria-hidden="true"></div>
                        </div>
                      ) : null}
                      {shouldShowEmptyMessages ? (
                        <ChatRetentionEmptyNotice />
                      ) : null}
                    </div>

                    <ChatImageModal
                      isOpen={imgModalOpen && imageItems.length > 0}
                      src={imageItems[imgModalIndex]?.fullSrc}
                      downloadItems={imageItems}
                      currentIndex={imgModalIndex}
                      onClose={closeImageModal}
                      onPrev={showPrevImage}
                      onNext={showNextImage}
                      showNav={imageItems.length > 1}
                    />

                    {messageMenu ? (
                      <div className="group-chat-page__messageMenuOverlay" onClick={closeMessageMenu}>
                        <div
                          ref={messageMenuRef}
                          className="group-chat-page__messageMenu"
                          style={{ left: messageMenu.x, top: messageMenu.y }}
                          onClick={(event) => event.stopPropagation()}
                        >
                          {canReactMessage(messageMenu.message) ? (
                            <ChatMessageMenuReactionPicker
                              messageId={messageMenu.messageId}
                              reactions={messageMenu.message?.reactions}
                              onSelectReaction={handleMessageMenuReactionSelect}
                              isPending={isReactionPending}
                            />
                          ) : null}
                          {canReplyMessage(messageMenu.message) ? (
                            <button
                              type="button"
                              className="group-chat-page__messageMenuItem"
                              onClick={handleSelectReplyMessage}
                            >
                              <i className="fa-solid fa-reply" aria-hidden="true" />
                              <span>返信する</span>
                            </button>
                          ) : null}
                          {canCopyMessage(messageMenu.message) ? (
                            <button
                              type="button"
                              className="group-chat-page__messageMenuItem"
                              onClick={handleCopyMessage}
                            >
                              <i className="fa-solid fa-copy" aria-hidden="true" />
                              <span>コピー</span>
                            </button>
                          ) : null}
                          {canCopyMessage(messageMenu.message) ? (
                            <button
                              type="button"
                              className="group-chat-page__messageMenuItem"
                              onClick={handleOpenInlinePartialCopy}
                            >
                              <i className="fa-solid fa-i-cursor" aria-hidden="true" />
                              <span>一部をコピー</span>
                            </button>
                          ) : null}
                          {canAnnouncementMessage(messageMenu.message) ? (
                            <button
                              type="button"
                              className="group-chat-page__messageMenuItem"
                              onClick={handleToggleAnnouncementMessage}
                              disabled={Boolean(announcementActionMessageId)}
                            >
                              <i
                                className={`fa-solid ${
                                  announcementActionMessageId === String(messageMenu.messageId || '')
                                    ? 'fa-spinner fa-spin'
                                    : isAnnouncedMessage(messageMenu.messageId)
                                      ? 'fa-bullhorn-slash'
                                      : 'fa-bullhorn'
                                }`}
                                aria-hidden="true"
                              />
                              <span>
                                {announcementActionMessageId === String(messageMenu.messageId || '')
                                  ? '処理中…'
                                  : isAnnouncedMessage(messageMenu.messageId)
                                    ? 'アナウンス解除'
                                    : 'アナウンスに設定'}
                              </span>
                            </button>
                          ) : null}
                          {canInspectReadStatus(messageMenu.message) ? (
                            <button
                              type="button"
                              className="group-chat-page__messageMenuItem"
                              onClick={handleOpenReadStatusDetail}
                            >
                              <i className="fa-solid fa-check-double" aria-hidden="true" />
                              <span>既読を確認</span>
                            </button>
                          ) : null}
                          {canUnsendMessage(messageMenu.message) ? (
                            <button
                              type="button"
                              className="group-chat-page__messageMenuItem group-chat-page__messageMenuItem--danger"
                              onClick={handleUnsendMessage}
                              disabled={Boolean(unsendingMessageId)}
                            >
                              {unsendingMessageId ? '処理中…' : '送信取り消し'}
                            </button>
                          ) : null}
                        </div>
                      </div>
                    ) : null}

                    <ChatComposer
                      mode="admin"
                      scope="group"
                      groupThreadId={selectedThreadId}
                      replyDraft={replyDraft}
                      onReplyCancel={() => setReplyDraft(null)}
                      onSent={handleComposerSent}
                      mentionCandidates={mentionCandidates}
                      readOnly={!selectedThread || selectedThread.status !== 'open'}
                    />
                  </>
                )}
              </>
            )}
          </div>

          {shouldShowSidePanel ? (
            <aside
              className={`chat-side-panel side-panel admin-chat-side-panel${
                isSidePanelOpen ? '' : ' chat-side-panel--collapsed'
              }`}
            >
              {isSidePanelOpen ? (
                <>
                  <ChatSidePanelHeader
                    icon="fa-comments"
                    label="チャット情報"
                    onCollapse={() => setIsSidePanelOpen(false)}
                  />
                  <ChatSidePanelCard title="">
                    <ChatSidePanelProfileBlock
                      avatarClassName="side-avatar group-chat-page__avatar"
                      avatarClickableClassName=""
                      avatarFallback={String(selectedThread.title || '').slice(0, 1) || 'G'}
                      name={selectedThread.title || 'タイトル未設定'}
                      metas={[
                        selectedThread.admin_muted ? (
                          <>
                            <i className="fa-solid fa-bell-slash" aria-hidden="true" />
                            <span style={{ marginLeft: 6 }}>通知オフ</span>
                          </>
                        ) : '',
                        `ステータス: ${getThreadStatusLabel(selectedThread.status)}`,
                        selectedThread.linked_artist_group_name
                          ? `連動グループ: ${selectedThread.linked_artist_group_name}`
                          : '',
                        selectedThread.linked_event_name
                          ? `連動イベント: ${selectedThread.linked_event_name}`
                          : '',
                      ].filter(Boolean)}
                      metaClassName="side-meta"
                    />
                  </ChatSidePanelCard>

                  <GroupChatParticipantsPanel
                    {...createGroupParticipantsPanelProps({
                      assignees: Array.isArray(selectedThread.assignees) ? selectedThread.assignees : [],
                      groupedArtists: groupedSidePanelArtists,
                      onSelectAssignee: (assignee) => {
                        const profile = buildAdminProfileData(assignee);
                        openAdminProfile(profile);
                      },
                      onSelectArtist: (artist) => {
                        const profile = buildArtistProfileData(artist);
                        openArtistProfile(profile);
                      },
                      buildAssetUrl,
                      appendVariant,
                      adminProfilePath: ADMIN_PROFILE_IMAGE_PATH,
                      artistProfilePath: ARTIST_PROFILE_IMAGE_PATH,
                      assigneeEmptyText: '担当者は設定されていません。',
                      artistEmptyText: '参加アーティストがいません。',
                      assigneeMetaFallback: '管理者',
                      artistNameFallback: '名称未設定',
                      resolveArtistKey: (artist, index, group) => {
                        const artistId = String(artist?.artist_id || artist?.id || '').trim();
                        return artistId || `side-artist-${String(group?.key || 'group')}-${index}`;
                      },
                      assigneeNameStyle: { fontSize: 12 },
                      artistNameStyle: { fontSize: 12 },
                      artistRowClassName: 'group-chat-page__artistRow side-panel-profile side-panel-profile--clickable',
                      artistAvatarClassName: 'group-chat-page__artistAvatar',
                    })}
                  />
                </>
              ) : (
                <div className="chat-side-panel__collapsed-rail">
                  <ChatSidePanelToggleButton
                    isOpen={false}
                    onToggle={() => setIsSidePanelOpen(true)}
                    label="チャット情報"
                    iconOnly
                    className="chat-side-panel__collapsed-toggle"
                  />
                </div>
              )}
            </aside>
          ) : null}
        </div>
        </ChatWorkspaceLayout>
      </div>

      <div className="admin-group-chat-container group-chat-page__modalScope">
        {showSettingsModal && settingsModalThread && (
          <MemberListModalLayout
            onClose={closeSettingsModal}
            dialogClassName="admin-group-chat-container member-modal__dialog group-chat-page__settingsModalDialog"
            titleClassName="member-modal__title"
            titleIconClassName="fa-solid fa-gear"
            titleText="グループチャット設定"
            bodyClassName="member-modal__body"
          >
              <section className="group-chat-page__settingsSummary">
                <div className="group-chat-page__settingsTitle">
                  {settingsModalThread.title || 'タイトル未設定'}
                </div>
                <div className="group-chat-page__settingsBadges">
                  <span
                    className={`group-chat-page__settingsBadge ${
                      settingsModalThread.status === 'open' ? 'is-open' : 'is-closed'
                    }`}
                  >
                    {getThreadStatusLabel(settingsModalThread.status)}
                  </span>
                  <span className="group-chat-page__settingsBadge is-muted">
                    {getThreadModeLabel(settingsModalThread.mode)}
                  </span>
                </div>
              </section>

              <div className="settings-modal__body">
                <div className="group-chat-page__settingsSection">
                  <div className="group-chat-page__settingsSectionHeader">
                    <div className="group-chat-page__settingsSectionTitle">基本情報</div>
                    <div className="group-chat-page__settingsSectionSub">タイトルとアイコンを管理します。</div>
                  </div>
                  <div className="settings-modal__section group-chat-page__iconSection">
                    <div className="settings-modal__section-text group-chat-page__compactField">
                      <p className="settings-modal__label">グループチャットアイコン</p>
                      <p className="group-chat-page__fieldHint">推奨: 正方形 / 512px以上</p>
                    </div>
                    <div className="group-chat-page__iconEditor">
                      <div
                        className="group-chat-page__settingsIconPreview"
                        style={getGroupChatIconStyle(settingsModalThread)}
                        aria-hidden="true"
                      >
                        {!settingsModalThread?.icon_file &&
                          ((String(settingsModalThread?.title || settingsTitle || 'G').trim().charAt(0) || 'G'))}
                      </div>
                      <div className="group-chat-page__iconActions">
                        <input
                          ref={settingsIconFileInputRef}
                          type="file"
                          accept={IMAGE_UPLOAD_ACCEPT_ATTR}
                          onChange={handleIconFileChange}
                          className="group-chat-page__hiddenFileInput"
                        />
                        <button
                          type="button"
                          className="group-chat-page__iconActionButton"
                          onClick={() => settingsIconFileInputRef.current?.click()}
                          disabled={uploadingIcon || deletingIcon}
                        >
                          {uploadingIcon
                            ? 'アップロード中...'
                            : settingsModalThread?.icon_file
                              ? 'アイコンを変更'
                              : 'アイコンを追加'}
                        </button>
                        {settingsModalThread?.icon_file ? (
                          <button
                            type="button"
                            className="group-chat-page__iconActionButton is-danger"
                            onClick={handleDeleteIcon}
                            disabled={uploadingIcon || deletingIcon}
                          >
                            {deletingIcon ? '削除中...' : 'アイコンを削除'}
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="settings-modal__section group-chat-page__settingsField">
                    <div className="settings-modal__section-text group-chat-page__compactField">
                      <p className="settings-modal__label">チャットタイトル</p>
                      <p className="group-chat-page__fieldHint">80文字以内</p>
                    </div>
                    <input
                      type="text"
                      value={settingsTitle}
                      onChange={(event) => setSettingsTitle(event.target.value)}
                      maxLength={80}
                      placeholder="グループ名を入力"
                      className="group-chat-page__settingsInput"
                    />
                  </div>
                </div>

                <div className="group-chat-page__settingsSection">
                  <div className="group-chat-page__settingsSectionHeader">
                    <div className="group-chat-page__settingsSectionTitle">通知</div>
                    <div className="group-chat-page__settingsSectionSub">グループチャット通知のオン/オフ</div>
                  </div>
                  <div className="settings-modal__section group-chat-page__notificationRow">
                    <div className="settings-modal__section-text group-chat-page__compactField">
                      <p className="settings-modal__label">通知オン</p>
                      <p className="settings-modal__description">オフにすると、メール/LINE/プッシュ通知を受け取りません。</p>
                    </div>
                    <div className="group-chat-page__notificationControl">
                      <div className="group-chat-page__muteStatus">
                        {savingMute ? '更新中…' : (threadMuted ? '通知オフ' : '通知オン')}
                      </div>
                      <DsSwitch
                        checked={!threadMuted}
                        onChange={handleToggleMute}
                        onError={() => {}}
                        disabled={loadingMute || savingMute}
                        ariaLabel="このチャットの通知オンオフ"
                      />
                    </div>
                  </div>
                </div>

                <div className="group-chat-page__settingsSection">
                  <div className="group-chat-page__settingsSectionHeader">
                    <div className="group-chat-page__settingsSectionTitle">担当管理者</div>
                    <div className="group-chat-page__settingsSectionSub">担当者を設定して共有します。</div>
                  </div>
                  <div className="settings-modal__section group-chat-page__assigneeSection">
                    <div className="settings-modal__section-text group-chat-page__compactField">
                      <p className="settings-modal__label">担当管理者</p>
                      <p className="group-chat-page__fieldHint">複数選択が可能です。</p>
                    </div>
                    <div className="group-chat-page__assigneeSummary">
                      <div className="group-chat-page__assigneeChipList">
                        {selectedAssignees.length > 0 ? (
                          selectedAssignees.map((admin) => {
                            const displayName = admin.full_name || admin.username || `管理者#${admin.id}`;
                            const initial = String(displayName || 'A').trim().charAt(0) || 'A';
                            const adminAvatarStyle = getAdminAvatarStyle(admin);
                            return (
                              <span key={String(admin?.id || displayName)} className="group-chat-page__assigneeChip">
                                <span
                                  className="group-chat-page__assigneeChipInitial"
                                  style={adminAvatarStyle}
                                >
                                  {!adminAvatarStyle ? initial : ''}
                                </span>
                                <span className="group-chat-page__assigneeChipName">{displayName}</span>
                              </span>
                            );
                          })
                        ) : (
                          <div className="group-chat-page__miniEmpty">未設定</div>
                        )}
                      </div>
                      <div className="group-chat-page__assigneeSummaryFooter">
                        <div className="group-chat-page__assigneeSummaryCount">
                          選択: {selectedAssigneeNames.length} 名
                        </div>
                        <button
                          type="button"
                          className="group-chat-page__iconActionButton"
                          onClick={openAssigneeModal}
                          disabled={loadingAdminUsers}
                        >
                          {loadingAdminUsers ? '読み込み中...' : '担当管理者を選択'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="group-chat-page__settingsSection group-chat-page__dangerSection">
                  <div className="group-chat-page__settingsSectionHeader">
                    <div className="group-chat-page__settingsSectionTitle">削除</div>
                    <div className="group-chat-page__settingsSectionSub">グループチャットを完全に削除します。</div>
                  </div>
                  <div className="settings-modal__section group-chat-page__dangerSectionBody">
                    <p className="group-chat-page__dangerDescription">
                      メッセージ、メンバー、設定、添付ファイルを含む関連データはすべて物理削除されます。元に戻せません。
                    </p>
                    <button
                      type="button"
                      className="group-chat-page__iconActionButton is-danger"
                      onClick={handleDeleteThread}
                      disabled={deletingThread || savingSettings || loadingThreadDetail}
                    >
                      {deletingThread ? '削除中...' : 'グループチャットを削除'}
                    </button>
                  </div>
                </div>
              </div>

              <div className="group-chat-page__modalActions">
                <button
                  type="button"
                  className="is-primary"
                  onClick={handleSaveSettings}
                  disabled={savingSettings || deletingThread || loadingThreadDetail}
                >
                  {savingSettings ? '保存中...' : '設定を保存'}
                </button>
              </div>
          </MemberListModalLayout>
      )}

      {showAssigneeModal && settingsModalThread && (
        <MemberListModalLayout
          onClose={closeAssigneeModal}
          dialogClassName="admin-group-chat-container member-modal__dialog settings-modal group-chat-page__assigneeModal"
          titleClassName="member-modal__title settings-modal__title"
          titleIconClassName="fa-solid fa-user-check"
          titleText="担当管理者の選択"
          bodyClassName="member-modal__body"
        >
            <p className="settings-modal__subtitle">
              {settingsModalThread.title || 'タイトル未設定'} / {getThreadModeLabel(settingsModalThread.mode)}
            </p>

            <div className="group-chat-page__assigneeToolbar">
              <div className="group-chat-page__assigneeSearch">
                <input
                  type="text"
                  value={assigneeKeyword}
                  onChange={(event) => setAssigneeKeyword(event.target.value)}
                  placeholder="名前 / ユーザー名で検索"
                />
              </div>
              <div className="group-chat-page__assigneeCount">
                選択: {assigneeDraftIds.length} / {adminUsers.length}
              </div>
            </div>

            <div className="settings-modal__body group-chat-page__assigneeBody">
              <div className="group-chat-page__assigneeList">
                {loadingAdminUsers ? (
                  <div className="group-chat-page__miniEmpty">読み込み中...</div>
                ) : filteredAdminUsers.length > 0 ? (
                  filteredAdminUsers.map((admin) => {
                    const adminId = Number.parseInt(admin?.id, 10);
                    const checked = assigneeDraftIds.includes(adminId);
                    const displayName = admin.full_name || admin.username || `管理者#${adminId}`;
                    const initial = String(displayName || 'A').trim().charAt(0) || 'A';
                    const adminAvatarStyle = getAdminAvatarStyle(admin);
                    return (
                      <label
                        key={adminId}
                        className={`group-chat-page__assigneeCard${checked ? ' is-selected' : ''}`}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => toggleAssigneeDraft(adminId)}
                        />
                        <span className="group-chat-page__assigneeAvatar" style={adminAvatarStyle}>
                          {!adminAvatarStyle ? initial : ''}
                        </span>
                        <span className="group-chat-page__assigneeInfo">
                          <span className="group-chat-page__assigneeName">{displayName}</span>
                          <span className="group-chat-page__assigneeRole">{admin.position || '管理者'}</span>
                        </span>
                        {checked && <span className="group-chat-page__assigneeCheck">✓</span>}
                      </label>
                    );
                  })
                ) : (
                  <div className="group-chat-page__miniEmpty">
                    {String(assigneeKeyword || '').trim()
                      ? '検索条件に一致する管理者がいません。'
                      : '管理者が見つかりません。'}
                  </div>
                )}
              </div>
            </div>

            <div className="group-chat-page__modalActions">
              <button
                type="button"
                className="is-primary"
                onClick={applyAssigneeModal}
                disabled={loadingAdminUsers}
              >
                選択を反映
              </button>
            </div>
        </MemberListModalLayout>
      )}

      {showMembersModal && selectedThread && (
        <MemberListModalLayout
          onClose={closeMembersModal}
          dialogClassName="admin-group-chat-container member-modal__dialog group-chat-page__membersModalDialog"
          titleClassName="member-modal__title"
          bodyClassName="member-modal__body"
        >
          {loadingMembers ? (
            <section className="member-modal__section">
              <h4 className="member-modal__section-title">担当管理者</h4>
              <div className="member-modal__empty">読み込み中...</div>
            </section>
          ) : (
            <MemberListModalContent
              admins={Array.isArray(membersPayload?.assignees) ? membersPayload.assignees : []}
              onAdminClick={(admin) => {
                const profile = buildAdminProfileData(admin);
                openAdminProfile(profile);
              }}
              adminKeyResolver={(admin, idx) =>
                String(admin?.id || admin?.admin_user_id || admin?.username || `assignee-${idx}`)
              }
              formatAdminName={formatAdminNameForMemberPeople}
              resolveAdminMembershipLabel={() => ''}
              adminAvatarStyle={adminAvatarStyleForMemberPeople}
              adminInitial={adminInitialForMemberPeople}
              responsibleEmptyText="担当管理者は設定されていません。"
              showArtistMembers
              isGroupMode
              groupArtistSections={groupedMemberArtistSections}
              onArtistClick={(artist) => {
                const profile = buildArtistProfileData(artist);
                openArtistProfile(profile);
              }}
              avatarStyle={artistAvatarStyleForMemberPeople}
              avatarInitial={artistAvatarInitialForMemberPeople}
              artistEmptyText="参加アーティストがいません。"
              groupShowMembership={false}
              groupShowBadges
              groupIncludeCustomRoles
              renderGroupMemberTrailing={(artist) => {
                if (membersPayload?.mode !== 'manual') return null;
                const artistId = String(artist?.id || artist?.artist_id || '').trim();
                if (!artistId) return null;
                const disabled = removingArtistId === artistId;
                return (
                  <button
                    type="button"
                    className="group-chat-page__memberRemove"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleRemoveMember(artistId);
                    }}
                    disabled={disabled}
                  >
                    {disabled ? '削除中...' : '削除'}
                  </button>
                );
              }}
            />
          )}
          {membersPayload?.mode === 'manual' ? (
            <button
              type="button"
              className="group-chat-page__openArtistModalButton group-chat-page__memberAddAction"
              onClick={openMembersAddModal}
            >
              メンバーを追加
            </button>
          ) : null}
        </MemberListModalLayout>
      )}

      {showMembersAddModal && showMembersModal && selectedThread && membersPayload?.mode === 'manual' && (
        <MemberListModalLayout
          onClose={closeMembersAddModal}
          dialogClassName="admin-group-chat-container member-modal__dialog settings-modal__content group-chat-page__createArtistModal group-chat-page__membersAddModal"
          titleClassName="member-modal__title"
          titleIconClassName="fa-solid fa-user-plus"
          titleText="メンバー追加"
          bodyClassName="member-modal__body"
        >
          <ArtistCandidateSelectorPanel
            title="メンバー追加"
            subtitle="追加したいアーティストを選択してください。"
            showTitle={false}
            candidateCount={manualCandidateRows.length}
            selectedCount={candidateSelection.length}
            keyword={artistKeyword}
            onKeywordChange={setArtistKeyword}
            accountType={memberAddAccountType}
            onAccountTypeChange={setMemberAddAccountType}
            groupId={memberAddFilterGroupId}
            onGroupIdChange={setMemberAddFilterGroupId}
            partId={memberAddFilterPart}
            onPartIdChange={setMemberAddFilterPart}
            groups={artistGroups}
            parts={parts}
            loadingGroups={loadingGroups}
            loadingParts={loadingParts}
            onSelectAll={addAllMemberCandidates}
            selectAllDisabled={manualCandidateRows.length === 0}
            selectAllLabel="表示アーティストをすべて選択"
            onClearSelection={() => setCandidateSelection([])}
            clearDisabled={candidateSelection.length === 0}
            loadingCandidates={loadingArtistCandidates}
            candidates={manualCandidateRows}
            isSelectedCandidate={(artist) =>
              candidateSelection.includes(String(artist?.artist_id || '').trim())
            }
            onToggleCandidate={(artist) => toggleCandidate(String(artist?.artist_id || '').trim())}
            resolveShortPart={resolveArtistShortPart}
            emptyText="追加可能な候補がありません。"
            onConfirm={handleAddMembers}
            confirmLabel={addingMembers ? '追加中...' : `選択した${candidateSelection.length}人を追加`}
            confirmDisabled={addingMembers || candidateSelection.length === 0}
          />
        </MemberListModalLayout>
      )}

      {createOpen && (
        <MemberListModalLayout
          onClose={() => setCreateOpen(false)}
          dialogClassName="admin-group-chat-container member-modal__dialog group-chat-page__createModal"
          titleClassName="member-modal__title"
          titleIconClassName="fa-solid fa-comments"
          titleText="グループチャット作成"
          bodyClassName="member-modal__body"
        >
              <label className="group-chat-page__formLabel">
                タイトル
                <input
                  type="text"
                  value={createTitle}
                  onChange={(event) => setCreateTitle(event.target.value)}
                  maxLength={80}
                />
              </label>
              <label className="group-chat-page__formLabel">
                モード
                <DsSelect value={createMode} onChange={(event) => setCreateMode(event.target.value)}>
                  <option value="manual">手動</option>
                  <option value="artist_group_linked">アーティストグループ連動</option>
                </DsSelect>
              </label>
              {createMode === 'manual' && (
                <div className="group-chat-page__formLabel group-chat-page__createArtistSelect">
                  <span>アーティスト選択</span>
                  <div className="group-chat-page__createArtistActions">
                    <button
                      type="button"
                      className="group-chat-page__openArtistModalButton"
                      onClick={() => setShowCreateArtistModal(true)}
                    >
                      アーティストを選択
                    </button>
                    <span className="group-chat-page__createArtistCount">
                      選択: {createSelectedArtists.length} 人
                    </span>
                  </div>
                  {createSelectedArtists.length > 0 ? (
                    <div className="group-chat-page__createSelectedChipList">
                      {createSelectedArtists.map((artist) => {
                        const artistId = String(artist?.artist_id || '').trim();
                        return (
                          <button
                            key={artistId}
                            type="button"
                            className="group-chat-page__createSelectedChip"
                            onClick={() => removeCreateArtist(artistId)}
                            title="クリックで選択解除"
                          >
                            <span
                              className="group-chat-page__artistAvatar"
                              style={getArtistAvatarStyle(artist)}
                            >
                              {!getArtistPictureKey(artist) &&
                                (artist.name?.charAt(0) || artist.name_en?.charAt(0) || '?')}
                            </span>
                            <span className="group-chat-page__createSelectedChipName">
                              {artist.name || artist.name_en || '名称未設定'}
                            </span>
                            <span className="group-chat-page__createSelectedChipRemove">×</span>
                          </button>
                          );
                        })}
                      <AdminGroupChatGuidanceMessage />
                    </div>
                  ) : (
                    <div className="group-chat-page__miniEmpty">
                      手動モードでは、作成時に対象アーティストを選択できます。
                    </div>
                  )}
                </div>
              )}
              {createMode === 'artist_group_linked' && (
                <label className="group-chat-page__formLabel">
                  連動グループ
                  <DsSelect
                    value={createGroupId}
                    onChange={(event) => setCreateGroupId(event.target.value)}
                    disabled={loadingGroups}
                  >
                    <option value="">選択してください</option>
                    {artistGroups.map((group) => (
                      <option key={group.group_id} value={group.group_id}>
                        {group.group_name}
                      </option>
                    ))}
                  </DsSelect>
                </label>
              )}
              <div className="group-chat-page__modalActions">
                <button type="button" onClick={handleCreate} disabled={savingCreate}>
                  作成
                </button>
              </div>
        </MemberListModalLayout>
      )}

      {showCreateArtistModal && createOpen && createMode === 'manual' && (
        <MemberListModalLayout
          onClose={() => setShowCreateArtistModal(false)}
          dialogClassName="admin-group-chat-container member-modal__dialog settings-modal__content group-chat-page__createArtistModal"
          titleClassName="member-modal__title"
          titleIconClassName="fa-solid fa-users"
          titleText="アーティスト選択"
          bodyClassName="member-modal__body"
        >
          <ArtistCandidateSelectorPanel
            title="アーティスト選択"
            subtitle="グループチャットに追加するアーティストを選択します。"
            showTitle={false}
            candidateCount={createArtistCandidates.length}
            selectedCount={createSelectedArtists.length}
            keyword={createArtistKeyword}
            onKeywordChange={setCreateArtistKeyword}
            accountType={createArtistAccountType}
            onAccountTypeChange={setCreateArtistAccountType}
            groupId={createArtistFilterGroupId}
            onGroupIdChange={setCreateArtistFilterGroupId}
            partId={createArtistFilterPart}
            onPartIdChange={setCreateArtistFilterPart}
            groups={artistGroups}
            parts={parts}
            loadingGroups={loadingGroups}
            loadingParts={loadingParts}
            onSelectAll={addAllCreateCandidates}
            selectAllDisabled={createArtistCandidates.length === 0}
            selectAllLabel="表示アーティストをすべて追加"
            onClearSelection={() => setCreateSelectedArtists([])}
            clearDisabled={createSelectedArtists.length === 0}
            loadingCandidates={loadingCreateArtistCandidates}
            candidates={createArtistCandidates}
            isSelectedCandidate={(artist) =>
              createSelectedArtistIdSet.has(String(artist?.artist_id || '').trim())
            }
            onToggleCandidate={toggleCreateArtist}
            resolveShortPart={resolveArtistShortPart}
            emptyText="条件に一致するアーティストがいません。"
            onConfirm={() => setShowCreateArtistModal(false)}
            confirmLabel="選択を確定"
          />
        </MemberListModalLayout>
      )}

      <ChatProfileModalLayer
        profileTarget={profileTarget}
        onClose={closeProfileModal}
        allowArtistLink
      />
      <ChatAnnouncementListModal
        open={isAnnouncementListOpen}
        announcements={announcements}
        onClose={() => setIsAnnouncementListOpen(false)}
        onRemove={unpinAnnouncement}
        removingMessageId={announcementActionMessageId}
        onSelect={handleSelectAnnouncementMessage}
      />
      <ChatMessageReactionDetailModal
        open={isReactionDetailOpen}
        loading={reactionDetailLoading}
        groups={reactionDetailGroups}
        onClose={closeReactionDetail}
      />
      <ChatMessageReadStatusDetailModal
        open={isReadStatusDetailOpen}
        loading={readStatusDetailLoading}
        readers={readStatusDetailReaders}
        onClose={closeReadStatusDetail}
      />
      <ChatMentionTaskResolutionModal {...mentionResolutionModalProps} />

      <ChatLinksModal
        isOpen={showLinksModal}
        loadLinks={chatAssetSource?.loadLinks}
        onClose={() => setShowLinksModal(false)}
      />
      <ChatMediaModal
        isOpen={showMediaModal}
        loadMedia={chatAssetSource?.loadMedia}
        downloadZip={chatAssetSource?.downloadZip}
        buildFileUrl={chatAssetSource?.buildFileUrl}
        onClose={() => setShowMediaModal(false)}
      />
      <ChatFollowupNotificationMenu
        menu={followupNotificationMenu}
        onClose={closeFollowupNotificationMenu}
        toastError={toastError}
        toastSuccess={toastSuccess}
      />
      </div>

      <CropModal
        show={showIconCropModal}
        src={iconCropImageSrc}
        onSave={handleSaveCroppedIcon}
        onCancel={() => {
          setShowIconCropModal(false);
          setIconCropImageSrc('');
          if (settingsIconFileInputRef.current) {
            settingsIconFileInputRef.current.value = '';
          }
        }}
      />
    </div>);
}
